import LateActivitiesCounterSkeleton from "./LateActivitiesCounterSkeleton";
import LawsuitCounterSkeleton from "./LawsuitCounterSkeleton";
import LawsuitUpdateCounterSkeleton from "./LawsuitUpdateCounterSkeleton";
import DoneActivitiesByMonthSkeleton from "./DoneActivitiesByMonthSkeleton";
import LawsuitTrackerLineSkeleton from "./LawsuitTrackerLineSkeleton";
import InProgressActivitiesSkeleton from "./InProgressActivitiesSkeleton";

export {
  LateActivitiesCounterSkeleton,
  LawsuitCounterSkeleton,
  LawsuitUpdateCounterSkeleton,
  DoneActivitiesByMonthSkeleton,
  LawsuitTrackerLineSkeleton,
  InProgressActivitiesSkeleton,
};
